module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentWidget.type === 'author-carousel') ? _c('author-carousel', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "maxItems": 20,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange,
      "setWidgetData": function($event) {
        _vm.$emit('setWidgetData', $event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa8435b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalMultiAuthor.vue
// module id = 686
// module chunks = 1